import {CalendarEventForDayResponse} from "@/types/service-response";
import {Kind} from "@/types/payload";

export default class CalendarEventForDay {
    private constructor(
        readonly id: string,
        readonly kind: Kind,
        readonly date: string
    ) {
    }

    public static createCalendarEventForDay(responseCalendarNewEventForDay: CalendarEventForDayResponse): CalendarEventForDay {
        return new CalendarEventForDay(
            responseCalendarNewEventForDay.id,
            responseCalendarNewEventForDay.kind,
            responseCalendarNewEventForDay.date
        )
    }

    public static createCalendarEvent(responseCalendarEventsForDay: CalendarEventForDayResponse[]): CalendarEventForDay[] {
        return responseCalendarEventsForDay.map((item: CalendarEventForDayResponse) => {
            return new CalendarEventForDay(
                item.id,
                item.kind,
                item.date

            )
        })
    }
}